console.log('ActonFunder')

function setupImageCycling() {
    const container = document.querySelector('.af-home-bg');
    const images = container.querySelectorAll('.af-home-bg__img');
    const captions = container.querySelectorAll('.af-home-caption');
    let currentIndex = 0;

    function cycleContent() {
        // Remove active class from current image and caption
        images[currentIndex].classList.remove('active');
        captions[currentIndex].classList.remove('active');
        
        // Move to next index
        currentIndex = (currentIndex + 1) % images.length;
        
        // Add active class to new image and caption
        images[currentIndex].classList.add('active');
        captions[currentIndex].classList.add('active');
    }

    // Start cycling every 60 seconds
    setInterval(cycleContent, 45000);
}

document.addEventListener('DOMContentLoaded', () => {

 setupImageCycling();


});